import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../redux/module/custom_str";

export default function FilterMachine({ typeFilter, setFilterType, filterOptionsMachine, setQuery }) {
  const dispatch = useDispatch();

  const list_brand = useSelector((state) => state.item_machine.brands);
  const list_coil = [
    { title: "일체형", detail: "팟과 코일이 합쳐져서 나오는 기기" },
    { title: "분리형", detail: "팟 따로, 코일 따로 구매해서 사용하는 기기" },
  ];
  const list_draw = [
    {
      title: "오토 드로우 기능 있음",
      detail: "버튼을 누르지 않아도 베이핑 가능",
      autodraw: "y",
    },
    { title: "오토 드로우 기능 없음", detail: null, autodraw: "n" },
  ];

  const ref_brand = useRef([]);
  const tmp_brand = useRef([]);

  const ref_coil = useRef(new Array(list_coil.length).fill(false));
  const ref_draw = useRef(new Array(list_draw.length).fill(false));
  const tmp_coil = useRef([...ref_coil.current]);
  const tmp_draw = useRef([...ref_draw.current]);

  useEffect(() => {
    if (list_brand.length && !ref_brand.current.length) {
      ref_brand.current = new Array(list_brand.length).fill(false);
      tmp_brand.current = [...ref_brand.current];
    }
  }, [list_brand]);

  const handleFilter = (type) => {
    tmp_coil.current = [...ref_coil.current];
    tmp_draw.current = [...ref_draw.current];
    tmp_brand.current = [...ref_brand.current];
    setFilterType(type);
  };

  const MakeQuery = () => {
    let query_coil = "";
    for (let i = 0; i < ref_coil.current.length; i++) {
      if (ref_coil.current[i]) {
        if (query_coil) query_coil += `,${list_coil[i]["title"]}`;
        else query_coil += `machine_coiltype=${list_coil[i]["title"]}`;
      }
    }

    let query_draw = "";
    for (let i = 0; i < ref_draw.current.length; i++) {
      if (ref_draw.current[i]) {
        if (query_draw) query_draw += `,${list_draw[i]["autodraw"]}`;
        else query_draw += `machine_autodraw=${list_draw[i]["autodraw"]}`;
      }
    }

    let query_brand = "";
    for (let i = 0; i < ref_brand.current.length; i++) {
      if (ref_brand.current[i]) {
        if (query_brand) query_brand += `,${list_brand[i]}`;
        else query_brand += `item_company=${list_brand[i]}`;
      }
    }

    let query_final = "";
    query_final += query_coil ? query_coil : "";
    query_final += query_draw ? (query_final.length > 1 ? `&${query_draw}` : query_draw) : "";
    query_final += query_brand ? (query_final.length > 1 ? `&${query_brand}` : query_brand) : "";
    query_final += query_final.length > 1 ? "&" : "";

    // 쿼리 스트링에 특수문자가 들어가면 서버에서 문자열이 오염돼서
    // 퍼센트 인코딩 과정을 추가로 거쳐야 함.
    query_final = encodeURI(query_final);
    setQuery(query_final);
  };

  const ModalFeature = () => {
    const [select_coil, setCoil] = useState(tmp_coil.current);
    const [select_draw, setDraw] = useState(tmp_draw.current);

    return (
      <div className="overflow-y-scroll hide-scrollbar h-[345px]">
        <div className="font-bold text-left text-[#2B2B2B] mx-[16px]">
          팟,코일 유형
          <hr className="mt-[14px] mb-[7px] border-[#F4F4F4]" />
        </div>
        {list_coil.map((elem, itr) => (
          <div key={"machine_coil_" + itr}>
            <div
              className="flex justify-between px-[16px] pt-[7px] pb-[8px]"
              onClick={() => {
                tmp_coil.current[itr] = !tmp_coil.current[itr];
                setCoil([...tmp_coil.current]);
              }}
            >
              <div className="flex">
                <p className={`${select_coil[itr] ? "text-black" : ""}`}>{elem.title}</p>
                <p className="ml-[12px] self-center font-normal text-12px">{elem.detail}</p>
              </div>
              <p>
                {select_coil[itr] ? (
                  <img src="/imageDB/common/checked.svg" width={16} alt="checked" />
                ) : (
                  <img src="/imageDB/common/unchecked.svg" width={16} alt="unchecked" />
                )}
              </p>
            </div>
          </div>
        ))}
        <div className="font-bold text-left text-[#2B2B2B] mx-[16px] mt-[25px]">
          오토 드로우
          <hr className="mt-[14px] mb-[7px]" />
        </div>
        {list_draw.map((elem, itr) => (
          <div key={"machine_draw_" + itr}>
            <div
              className="flex justify-between px-[16px] pt-[7px] pb-[8px]"
              onClick={() => {
                tmp_draw.current[itr] = !tmp_draw.current[itr];
                setDraw([...tmp_draw.current]);
              }}
            >
              <div className="flex">
                <p className={`${select_draw[itr] ? "text-black" : ""}`}>{elem.title}</p>
                <p className="ml-[12px] self-center font-normal text-12px">{elem.detail}</p>
              </div>
              <p>
                {select_draw[itr] ? (
                  <img src="/imageDB/common/checked.svg" width={16} alt="checked" />
                ) : (
                  <img src="/imageDB/common/unchecked.svg" width={16} alt="unchecked" />
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const ModalBrand = () => {
    const [select_brand, setBrand] = useState(tmp_brand.current);

    return (
      <div className="overflow-y-scroll hide-scrollbar h-[345px]">
        {list_brand.map((elem, itr) => (
          <div key={"machine_brand_" + itr}>
            <div
              className="flex justify-between px-[16px] pt-[7px] pb-[8px]"
              onClick={() => {
                tmp_brand.current[itr] = !tmp_brand.current[itr];
                setBrand([...tmp_brand.current]);
              }}
            >
              <p className={`${select_brand[itr] ? "text-black" : ""}`}>{elem}</p>
              <p>
                {select_brand[itr] ? (
                  <img src="/imageDB/common/checked.svg" width={16} alt="checked" />
                ) : (
                  <img src="/imageDB/common/unchecked.svg" width={16} alt="unchecked" />
                )}
              </p>
            </div>
            {itr !== list_brand.length - 1 ? <hr className="mt-[8px] mb-[7px] border-[#F4F4F4]" /> : null}
          </div>
        ))}
      </div>
    );
  };

  return typeFilter ? (
    <>
      {/* 음영 */}
      <div className="absolute top-0 z-[22] w-full min-w-[360px] h-screen bg-[rgba(28,28,28)]/80" onClick={() => handleFilter(0)} />

      <div className="bg-white w-full min-w-[360px] h-[580px] rounded-t-[20px] fixed z-[22] bottom-0">
        <div className="w-[40px] h-[5px] rounded-[2.5px] bg-[#F0F0F0] mx-auto mt-[10px]" onClick={() => handleFilter(0)} />

        <div className="mt-[25px] mb-[28px] flex font-bold text-[#C3C3C3]">
          {/* 하단 메뉴 */}
          {filterOptionsMachine.map((elem, itr) => (
            <p className={`ml-[16px] ${typeFilter === itr + 1 ? "text-black" : null}`} key={"machine_filter_tab_" + itr} onClick={() => setFilterType(itr + 1)}>
              {elem}
            </p>
          ))}
        </div>
        <div className="text-[#A0A0A0] font-medium text-14px">
          {typeFilter === 1 ? <ModalFeature /> : typeFilter === 2 ? <ModalBrand /> : null}
          {/* <div className="absolute bottom-[81px] w-full mt-[12px] flex bg-teal-500"> */}
          {/* 이 부분은 마지막에 검토!! */}
          {/* {["김치볶음밥", "잔치국수", "튀김우동"].map((elem) => (
            <div className="bg-black rounded-[18.5px] text-white w-[79px] h-[37px] mr-[8px] flex flex-col justify-center">
              <p>{elem}</p>
            </div>
          ))}
        </div> */}
        </div>
        <div className="w-full min-w-[360px] h-[130px] flex absolute bottom-0">
          <div className="mt-[12px] mb-[17px] w-full relative">
            <button
              className="bg-white border border-[#E6E6E6] rounded-[8px] w-[114px] h-[52px] mr-[6px]"
              onClick={() => {
                ref_coil.current = new Array(list_coil.length).fill(false);
                ref_draw.current = new Array(list_draw.length).fill(false);
                ref_brand.current = new Array(list_brand.length).fill(false);
                dispatch(setSearchText(""));
                MakeQuery();
                handleFilter(0);
              }}
            >
              초기화
            </button>
            <button
              className="bg-black text-white rounded-[8px] w-[208px] h-[52px]"
              onClick={() => {
                ref_coil.current = [...tmp_coil.current];
                ref_draw.current = [...tmp_draw.current];
                ref_brand.current = [...tmp_brand.current];
                MakeQuery();
                handleFilter(0);
              }}
            >
              상품 보기
            </button>
          </div>
        </div>
      </div>
    </>
  ) : null;
}
